import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';


const QuickActionsCard = () => {
  const navigate = useNavigate();

  const quickActions = [
    {
      id: 1,
      label: "Explorar Negocios",
      description: "Busca descuentos cerca de ti",
      icon: "Search",
      color: "var(--color-primary)",
      bgColor: "bg-primary/10",
      action: () => navigate('/business-directory')
    },
    {
      id: 2,
      label: "Bizznet Rewards",
      description: "Gana comisiones por referidos",
      icon: "Award",
      color: "var(--color-secondary)",
      bgColor: "bg-secondary/10",
      action: () => navigate('/affiliate-dashboard')
    },
    {
      id: 3,
      label: "Mi Perfil",
      description: "Actualiza tu información",
      icon: "User",
      color: "var(--color-accent)",
      bgColor: "bg-accent/10",
      action: () => navigate('/user-profile-management')
    },
    {
      id: 4,
      label: "Soporte",
      description: "Contacta con nosotros",
      icon: "MessageCircle",
      color: "var(--color-success)",
      bgColor: "bg-success/10",
      action: () => window.open('https://wa.me/573123456789', '_blank')
    }
  ];

  return (
    <div className="bg-card rounded-lg border border-border p-6 shadow-card">
      <div className="flex items-center gap-3 mb-6">
        <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-accent/10">
          <Icon name="Zap" size={24} color="var(--color-accent)" />
        </div>
        <div>
          <h2 className="text-lg font-semibold text-foreground">Acciones Rápidas</h2>
          <p className="text-sm text-muted-foreground">Accede a funciones principales</p>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {quickActions?.map((action) => (
          <button
            key={action?.id}
            onClick={action?.action}
            className="flex items-start gap-4 p-4 bg-muted rounded-lg hover:bg-muted/80 transition-all duration-200 text-left group"
          >
            <div className={`flex items-center justify-center w-12 h-12 rounded-lg ${action?.bgColor} flex-shrink-0 group-hover:scale-110 transition-transform`}>
              <Icon name={action?.icon} size={24} color={action?.color} />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-semibold text-foreground mb-1">{action?.label}</p>
              <p className="text-xs text-muted-foreground">{action?.description}</p>
            </div>
            <Icon name="ChevronRight" size={20} color="var(--color-muted-foreground)" className="flex-shrink-0 group-hover:translate-x-1 transition-transform" />
          </button>
        ))}
      </div>
    </div>
  );
};

export default QuickActionsCard;